<div>
    <ng-container *ngIf="loading">
        <div class="loading text-center">
            <br />
            <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
            <br />
            <p>Loading, please wait...</p>
        </div>
    </ng-container>

    <!--<div class="btns-container" style="position:absolute;top:15px;right:0px;">
        <a (click)="seeResults()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm margin-right-5" [ngClass]="{'btn-primary': canSeeResults, 'btn-gray': !canSeeResults}">
            <i class="fas fa-poll-h text-white-50"> <span class="button-text"> See results</span></i>
        </a>
    </div>-->

    <div *ngIf="!loading" style="width: 100%; max-height: 400px; height:400px;">
        <ag-grid-angular #agGrid
                         style="width: 100%; height: 100%;"
                         class="ag-theme-balham"
                         [enableFilter]="true"
                         [floatingFilter]="true"
                         [gridOptions]="gridOptions"
                         [rowData]="data"
                         [columnDefs]="dataHeaders"
                         [enableSorting]="true"
                         [enableColResize]="true"
                         (rowClicked)="onRowClicked($event)"
                         (gridReady)="onGridReady($event)"
                         [pagination]="true"
                         [paginationPageSize]="25"
                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                         [rowSelection]="rowSelection"
                         (rowSelected)="onRowSelected($event)" 
                         (selectionChanged)="onSelectionChanged($event)">
        </ag-grid-angular>
    </div>
</div>
